import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'

const CategoryForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        description: formData.description,
        remark:formData.remark
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          description: values.description,
          remark:values.remark
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  return (
    <Modal
      title= 'Edit category'
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Category Name">
          {getFieldDecorator(`name`, {
          })(<Input
            name="name"
            placeholder="Category Name" />)}
        </Form.Item>
        <Form.Item label="Description">
          {getFieldDecorator(`description`, {
          })(<Input
            name="description"
            placeholder="Description" />)}
        </Form.Item>
        <Form.Item label="Remark">
          {getFieldDecorator(`remark`, {
          })(<Input
            name="remark"
            placeholder="Remark" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
               Save
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedCategoryForm = Form.create({ name: 'CategoryForm' })(
  CategoryForm
)
export default WrappedCategoryForm


// WEBPACK FOOTER //
// ./src/pages/Category/components/CategoryForm/index.js